import script from "./LandingListTableColumnLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./LandingListTableColumnLayout.vue?vue&type=script&setup=true&lang=ts"

import "./LandingListTableColumnLayout.vue?vue&type=style&index=0&id=97e5a9b2&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97e5a9b2"]])

export default __exports__
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPopupProxy});
